<footer class="footer">
  <div class="container-fluid">
    <div class="footer-cnt">
      <ul>
        <li class="logo">
          <img src="assets/img/footer-logo.png" alt="The Data Cooks Logo" width="52" style="border-radius: 0;"/>
        </li>
        <li>
          &#169;
          <a href="https://thedatacooks.com/" target="_blank">
            The Data Cooks.
          </a>
          All Rights Reserved.
        </li>
      </ul>
    </div>
  </div>
</footer>
